import { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useForm } from "react-hook-form";
import NavBar from "../layout/NavBar";
import "../styles/profile.css";
import { coloresPorLetra } from "../static/colors.js";
import Modal2 from "../components/Modal";
import { toast } from "react-toastify";
import { http } from "../auth";
import { GoAlertFill } from "react-icons/go";

/*-----Iconos-----*/
import { IoBarcodeOutline } from "react-icons/io5";
import { TbCreditCardPay } from "react-icons/tb";
import {
  MdAdd,
  MdDownload,
  MdGavel,
  MdHolidayVillage,
  MdLocationCity,
  MdOutlineEditRoad,
} from "react-icons/md";
import { FaLandmarkFlag } from "react-icons/fa6";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { RiEdit2Fill, RiSubtractLine } from "react-icons/ri";
import { BiSolidPhoneCall } from "react-icons/bi";
import {
  Form,
  Tooltip,
  OverlayTrigger,
  Popover,
  Button,
  ButtonGroup,
  Modal,
  Row,
  Col,
} from "react-bootstrap";
import { useThemeManager } from "../Hooks/ThemeManager";

const Profile = () => {
  const { themeColors } = useThemeManager();
  let userName = localStorage.getItem("userName");
  const ID_user = localStorage.getItem("ID");
  const token = localStorage.getItem("token");
  const [dataSer, setDataSer] = useState(null);
  const [dataContact, setDataContact] = useState([]);
  const [isOpen, setIsOpen] = useState(null);
  const [contacto, setContacto] = useState(null);
  const [loading, setLoading] = useState(false);
  const [out1, setOut1] = useState(false);
  const [out2, setOut2] = useState(false);
  const [out3, setOut3] = useState(false);
  const [correoFields, setCorreoFields] = useState([]);
  const [show, setShow] = useState(false);
  const [isSwitchOn, setIsSwitchOn] = useState(false);
  const [tipoError, setTipoError] = useState("");

  const handleSwitchChange = (e) => {
    const isChecked = e.target.checked;

    if (!isChecked) {
      setShow(true);
    }
  };

  const handleCloseTerms = () => setShow(false);
  const handleShowTerms = () => {
    setShow(true);
  };

  const {
    control,
    register,
    handleSubmit,
    watch,
    formState: { errors },
    reset,
    setValue,
  } = useForm({});

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
    setContacto(null);
  };

  useEffect(() => {
    const dataServ = sessionStorage.getItem("dataServ");
    if (dataServ) {
      setDataSer(JSON.parse(dataServ));
    }
    fetchData();
  }, []);

  const fetchData = () => {
    setLoading(true);
    http
      .get(`/intranet-j/contactos`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setDataContact(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error en la solicitud:", error);
        setLoading(false);
      });
  };

  const onSubmit = (data) => {
    setLoading(true);
    let tipo = [];
    if (out1) tipo.push("ADMINISTRADOR");
    if (out2) tipo.push("PAGADOR");
    if (out3) tipo.push("TECNICO");

    if (tipo.length === 0) {
      setTipoError("Debe seleccionar al menos un tipo de contacto");
      setLoading(false);
      return;
    }

    setTipoError("");

    const correosExtras = correoFields
      .filter((campo) => campo.value.trim() !== "")
      .map((campo) => campo.value);

    data.administradores = {
      nombres: data.nombres,
      apellidos: data.apellidos,
      telefono: data.telefono.replace(/[^0-9]+/g, ""),
      email: data.email,
      estado: "ACTIVO",
      tipo: tipo,
      email_extra: correosExtras,
    };

    http
      .put(
        `/intranet-j/contactos/${contacto.id}`,
        data.administradores,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        toast.success("Se ha modificado el contacto correctamente.");
        setIsOpen(false);
        fetchData();
      })
      .catch((error) => {
        toast.error("Ha ocurrido un error al modificar el contacto.");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (isOpen) {
      setValue("nombres", contacto?.nombres);
      setValue("apellidos", contacto?.apellidos);
      setValue("telefono", contacto?.telefono);
      setValue("email", contacto?.email);
      setOut1(contacto?.tipo ? contacto.tipo.includes("ADMINISTRADOR") : false);
      setOut2(contacto?.tipo ? contacto.tipo.includes("PAGADOR") : false);
      setOut3(contacto?.tipo ? contacto.tipo.includes("TECNICO") : false);
      setCorreoFields(
        contacto?.email_extra !== null
          ? contacto?.email_extra?.map((email, index) => ({
            id: index + 1,
            value: email,
          }))
          : []
      );
    } else {
      reset();
    }
  }, [isOpen]);

  const handleCheckboxChange = (setter, value) => {
    setter(!value);
    if (tipoError) {
      setTipoError("");
    }
  };

  const handleRemoveItem = (id) => {
    const updatedFieldsCorreo = correoFields?.filter((field) => field.id !== id);
    setCorreoFields(updatedFieldsCorreo);
  };

  const handleAddItem = () => {
    const newIdCorreo = correoFields?.length + 1;
    setCorreoFields([...correoFields, { id: newIdCorreo, value: "" }]);

    const newInputElement = document.querySelector(
      `#campoPerfil-${newIdCorreo} input[type="email"]`
    );
    if (newInputElement) {
      // Smoothly scroll to the new input element with an optional offset
      newInputElement.scrollIntoView({
        behavior: "smooth",
        block: "center", // Center the element vertically within the viewport
        inline: "start", // Align the element to the left edge of the viewport (optional)
      });
    } else {
      console.warn("New input element not found. Scrolling may not work as expected.");
    }
  };

  const popover = (
    <Popover id="popover-basic">
      <Popover.Body>
        Información personal y opciones para gestionarla. Puedes hacer que parte de esta
        información, como tus datos de contacto, sea visible para otras personas para que puedan
        comunicarse contigo fácilmente. También puedes ver un resumen de tus perfiles.
      </Popover.Body>
    </Popover>
  );

  const getColorByInitialFont = (initial) => {
    if (!initial || initial.length < 1) {
      return "#505050";
    }
    const upperInitial = initial.toUpperCase().charAt(0);
    const color = coloresPorLetra[upperInitial] || "#cccccc";

    const luminance =
      (0.299 * parseInt(color.substr(1, 2), 16) +
        0.587 * parseInt(color.substr(3, 2), 16) +
        0.114 * parseInt(color.substr(5, 2), 16)) /
      255;

    return luminance > 0.45 ? "#000000" : "#ffffff";
  };

  return (
    <>
      <Modal className="modal-config" show={show} onHide={handleCloseTerms} centered>
        <div className="p-3">
          <div className="descripcion-config">
            <div>
              <GoAlertFill className="size-alert" />
            </div>
            <span className="text-alert">
              Actualmente, su suscripción a los servicios de pago online no se puede deshabilitar
            </span>
          </div>
          <div className="download-terms">
            <div className="icon-download">
              <MdDownload />
            </div>
            <span className="text-btn-down">Terminos condiciones del servicios de pago online</span>
            <div className="icon-download">
              <MdDownload />
            </div>
          </div>
          <div className="date-contract">
            <span>Aceptado</span>
            <span>25/11/2024</span>
          </div>
          <div style={{ marginLeft: "10px", marginRight: "10px", marginTop: "5px" }}>
            <Button onClick={handleCloseTerms} className="config-cancel">
              Cancelar
            </Button>
          </div>
        </div>
      </Modal>
      <Modal2
        titulo="Editar Contacto"
        button={
          <button
            type="submit"
            form="form"
            className="buttonSubmitModal"
            disabled={loading}
          >
            {loading ? <div className="spinner"></div> : "Guardar"}
          </button>
        }
        onClose={handleClose}
        isOpen={isOpen}
        modalWidth={"34%"}
        colorFondo="var(--azulClaro)"
      >
        <form id="form" onSubmit={handleSubmit(onSubmit)}>
          <div className="campoPerfil">
            <span className="formPerfilText">
              Tipo de contacto <span style={{ color: "red" }}>*</span>
            </span>
            <div className="contenedorChecks">
              <label className="checkPerfil">
                <input
                  type="checkbox"
                  checked={out1}
                  onChange={() => handleCheckboxChange(setOut1, out1)}
                />
                <span style={{ marginLeft: "5px" }}>Administrador</span>
              </label>
              <label className="checkPerfil">
                <input
                  type="checkbox"
                  checked={out2}
                  onChange={() => handleCheckboxChange(setOut2, out2)}
                />
                <span style={{ marginLeft: "5px" }}>Pagador</span>
              </label>
              <label className="checkPerfil">
                <input
                  type="checkbox"
                  checked={out3}
                  onChange={() => handleCheckboxChange(setOut3, out3)}
                />
                <span style={{ marginLeft: "5px" }}>Técnico</span>
              </label>
            </div>

            {tipoError && (
              <div className="mensaje-error-form" style={{ color: "red" }}>
                <span>{tipoError}</span>
              </div>
            )}
          </div>
          <div className="campoPerfilDual">
            <div className="campoPerfil">
              <span className="formPerfilText">Nombre</span>
              <input type="text" className="inputPerfil" {...register("nombres")} required />
            </div>
            <div className="campoPerfil">
              <span className="formPerfilText">Apellido</span>
              <input type="text" className="inputPerfil" {...register("apellidos")} required />
            </div>
          </div>
          <div className="campoPerfilDual">
            <div className="campoPerfil">
              <span className="formPerfilText">Correo electrónico</span>
              <input type="text" className="inputPerfil" {...register("email")} required />
            </div>
            <div className="campoPerfil">
              <span className="formPerfilText">Número de teléfono</span>
              <input type="text" className="inputPerfil" {...register("telefono")} required />
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "6px",
            }}
          >
            <div style={{ color: "#0d6efd", fontWeight: "bold" }}>
              Correos Extras: {correoFields?.length ? correoFields?.length : "0"}
            </div>
            <div className="buttomGroup">
              <button
                className="red"
                data-tip="Eliminar Correo"
                onClick={(e) => {
                  e.preventDefault();
                  if (correoFields?.length !== 0) {
                    handleRemoveItem(correoFields?.length);
                  }
                }}
              >
                <RiSubtractLine />
              </button>
              <button
                className="blue"
                data-tip="Agregar Correo"
                onClick={(e) => {
                  e.preventDefault();
                  handleAddItem();
                }}
              >
                <MdAdd />
              </button>
            </div>
          </div>
          <div className={correoFields.length > 1 ? "campoPerfilDual" : ""}>
            {correoFields?.map((field, index) => (
              <div key={field.id} className="campoPerfil indicador">
                <div className="indicador">N°{index}</div>
                <input
                  type="email"
                  className="inputPerfil"
                  value={field.value}
                  onChange={(e) => {
                    const updatedFields = [...correoFields];
                    updatedFields[index].value = e.target.value;
                    setCorreoFields(updatedFields);
                  }}
                />
              </div>
            ))}
          </div>
        </form>
      </Modal2>
      <div className="contenedorPerfil color-secondary">
        <Row>
          <Col xs={8}>
            <span className="tituloPerfil">
              Perfil
              <div className="popov">
                <OverlayTrigger trigger="click" placement="bottom" overlay={popover}>
                  <button className="eliminarBG ms-2">
                    <IoMdInformationCircleOutline className="mb-1" />
                  </button>
                </OverlayTrigger>
              </div>
            </span>
            <span className="subTituloPerfil">
              Información personal y opciones para gestionarla. Puedes hacer que parte de esta
              información, como tus datos de contacto, sea visible para otras personas para que
              puedan comunicarse contigo fácilmente. También puedes ver un resumen de tus perfiles.
            </span>
          </Col>
          <Col xs={4}>
            <div className="ms-auto phone-numbers">
              <div className="infoClienteConten">
                <div className="itemClientes">
                  {dataContact?.map((user, index) => (
                    <div
                      key={index}
                      className={`telefono-client ${index !== dataContact.length - 1 ? "horizontal-line" : ""
                        }`}
                    >
                      <div>
                        <BiSolidPhoneCall className="iconPhone" />
                        <span className="itemNombre">
                          <strong>Teléfono N° {index + 1}</strong>
                        </span>
                      </div>
                      <div className="">
                        <span>{user.telefono || "No disponible"}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </Col>
        </Row>
        {/* <div className="ms-auto">
               <div className="infoClienteConten">
              <div className="itemClientes">
                {dataContact?.map((user, index) => (
                  <div key={index} className="itemCliente">
                    <MdGavel className="iconCliente" />
                    <span className="itemNombre">Teléfono N°</span>
                    <span>{user.telefono || "No disponible"}</span>
                  </div>
                ))}
              </div>
            </div>
            </div> */}

        <div className="perfilContenedor loginIn">
          <div className="perfilHeader">
            <div
              className="usuario usuarioPerfil cursorNone"
              style={{
                backgroundColor: coloresPorLetra[userName.charAt(0).toUpperCase()],
                color: getColorByInitialFont(userName?.charAt(0).toUpperCase()),
              }}
            >
              {userName.charAt(0).toUpperCase()}
            </div>
            <div className="usuarioNombrePerfil">
              <span>{dataSer?.usuario[0].nombre_empresa}</span>
              <span>
                {dataSer?.usuario[0].dir_ciudad}, {dataSer?.usuario[0].dir_estado}
              </span>
            </div>
          </div>
          <div className="perfilBody color-secondary">
            <div className="infoContenedorPerfil">
              <div className="infoClientePerfil">
                <span className="tituloInformacion">Información Básica</span>
                <div className="infoClienteConten">
                  <div className="itemCliente">
                    <IoBarcodeOutline className="iconCliente" />
                    <span className="itemNombre">ID de la empresa</span>
                    <span>{dataSer?.usuario[0].id}</span>
                  </div>
                  <div className="itemCliente">
                    <MdGavel className="iconCliente" />
                    <span className="itemNombre">Registro fiscal</span>
                    <span>{dataSer?.usuario[0].rif_empresa}</span>
                  </div>
                </div>
              </div>
              <div className="direccionPerfil">
                <div className="infoClientePerfil">
                  {/*  <span className="tituloInformacion">Configuración de cobros</span>
                  <div className="infoClienteConten">
                    <div className="itemCliente">
                    <TbCreditCardPay  className="iconCliente" />
                      <span className="pagosOnline">Pagos online</span>
                      <div className="tag-config" onClick={handleShowTerms}>
                        <span>Activos</span>
                      </div>
                      <div className="btn-switch" onClick={handleSwitchChange}>
                        <Form.Check
                          type="switch"
                          id="custom-switch"
                          className="config-switch"
                          defaultChecked={isSwitchOn}
                          disabled={isSwitchOn}
                        />
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
              <div className="direccionPerfil">
                <span className="tituloInformacion">Dirección del cliente</span>
                <div className="infoClienteConten">
                  <div className="itemCliente">
                    <FaLandmarkFlag className="iconCliente" />
                    <span className="itemNombre">Estado</span>
                    <span>{dataSer?.usuario[0].dir_estado}</span>
                  </div>
                  <div className="itemCliente">
                    <MdLocationCity className="iconCliente" />
                    <span className="itemNombre">Ciudad</span>
                    <span>{dataSer?.usuario[0].dir_ciudad}</span>
                  </div>
                  <div className="itemCliente">
                    <MdHolidayVillage className="iconCliente" />
                    <span className="itemNombre">Urbanismo</span>
                    <span>{dataSer?.usuario[0].dir_urbanismo}</span>
                  </div>
                  <div className="itemCliente">
                    <MdOutlineEditRoad className="iconCliente" />
                    <span className="itemNombre">Calle/Avenida</span>
                    <span>{dataSer?.usuario[0].dir_calle}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="infoContenedorPerfil">
              <div className="infoContactoPerfil">
                <span className="tituloInformacion">Información de Contacto</span>
                <div className="contenedorContactosPerfil">
                  {loading ? (
                    <div className="contenSpinner">
                      <div class="spinner blue"></div>
                    </div>
                  ) : (
                    <>
                      {dataContact?.map((contacto, idx) => (
                        <div
                          key={idx}
                          className="contenContactoPerfil"
                          style={{ animation: `slideContactIn 0.8s ease forwards ${idx * 0.4}s` }}
                        >
                          <div className="contactoPerfil">
                            <div
                              className="usuario circuloContacto cursorNone"
                              style={{
                                backgroundColor:
                                  coloresPorLetra[contacto.nombres.charAt(0).toUpperCase()],
                                color: getColorByInitialFont(userName?.charAt(0).toUpperCase()),
                              }}
                            >
                              {contacto.nombres.charAt(0).toUpperCase()}
                            </div>
                            <div className="contactoInfo">
                              <span className="contactoInfoNombre">
                                {contacto.nombres} {contacto.apellidos}
                              </span>
                              <span className="contactoInfoSub">{contacto.email}</span>
                              <span className="contactoInfoSub">{contacto.telefono}</span>
                            </div>
                          </div>
                          <div className="accionesContacto">
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip id={`tooltip-top`}>
                                  {contacto?.tipo
                                    ?.map((t) => t.charAt(0) + t.slice(1).toLowerCase())
                                    .join(", ")}
                                </Tooltip>
                              }
                            >
                              <button className="eliminarBG">
                                <IoMdInformationCircleOutline />
                              </button>
                            </OverlayTrigger>
                            <RiEdit2Fill
                              onClick={() => {
                                handleOpen();
                                setContacto(contacto);
                              }}
                            />
                          </div>
                        </div>
                      ))}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Profile;
